import { MutableRefObject } from 'react';
import { centered, useSharedElement } from '@/components/use-shared-element';

export function useVideoModals(videoRef: MutableRefObject<HTMLVideoElement>) {
  const {
    props: videoModalProps,
    show: showVideoModal,
    hide: hideVideoModal,
  } = useSharedElement(
    {
      showBackdrop: true,
      extraFrom: {
        background: `#dedede`,
        opacity: `0`,
      },
      extraTo: {
        background: `white`,
        opacity: `1`,
      },
    },
    videoRef,
    () => centered(23, 42),
  );

  const {
    props: posterModalProps,
    show: showPosterModal,
    fromRef: posterImageRef,
    hide: hidePosterModal,
  } = useSharedElement(
    {
      showBackdrop: true,
      extraFrom: {
        background: `#dedede`,
        opacity: `0`,
      },
      extraTo: {
        background: `white`,
        opacity: `1`,
      },
    },
    undefined,
    () => centered(55, 80),
  );

  return {
    videoModalProps,
    showVideoModal,
    hideVideoModal,
    posterModalProps,
    showPosterModal,
    posterImageRef,
    hidePosterModal,
  };
}
